/**
 * Textos comuns às duas consoles e ao design system (packages/ui).
 * O inglês é a fonte: o tipo dele obriga pt-BR e es a terem exatamente as mesmas chaves.
 */
const en = {
  'ui.skip': 'Skip to content',
  'ui.close': 'Close',
  'ui.cancel': 'Cancel',
  'ui.confirm': 'Confirm',
  'ui.save': 'Save',
  'ui.saving': 'Saving…',
  'ui.back': 'Back',
  'ui.next': 'Next',
  'ui.edit': 'Edit',
  'ui.copy': 'Copy',
  'ui.copied': 'Copied to the clipboard.',
  'ui.copyFallback': 'Text selected — press Ctrl+C to copy.',
  'ui.loading': 'Loading…',
  'ui.retry': 'Try again',
  'ui.undo': 'Undo',
  'ui.dismiss': 'Dismiss',
  'ui.notifications': 'Notifications',
  'ui.openMenu': 'Open menu',
  'ui.closeMenu': 'Close menu',
  'ui.required': 'required',
  'ui.optional': 'optional',
  'ui.show': 'Show',
  'ui.hide': 'Hide',
  'ui.yes': 'Yes',
  'ui.no': 'No',
  'ui.none': '—',
  'ui.search': 'Search',
  'ui.all': 'All',
  'ui.actions': 'Actions',
  'ui.details': 'Details',
  'ui.loadMore': 'Load more',
  'ui.endOfList': 'End of the list',
  'ui.empty': 'Nothing here yet.',

  'wz.steps': 'Wizard steps',
  'wz.stepOf': 'Step {n} of {total} · {title}',
  'wz.saveDraft': 'Save draft',
  'wz.draftSavedAt': 'Draft saved at {time}',
  'wz.draftSavedToast': 'Draft saved. You can continue later from where you stopped — nothing you filled in was lost.',
  'wz.draftRestored': 'We restored the draft you saved {when}. Secret fields are never kept in drafts.',
  'wz.startOver': 'Start over',
  'wz.cancelTitle': 'Leave the wizard?',
  'wz.cancelText': 'What you filled in is kept as a draft and can be resumed later.',
  'wz.cancelOk': 'Leave and keep draft',
  'wz.finish': 'Finish',
  'wz.reviewLead': 'Check everything before saving. Use Edit to go back to a step without losing anything.',
  'wz.permCount': '{count} permissions',
  'wz.secretHidden': 'Hidden — stored in the vault',
  'wz.secretHint': 'Stored in the vault. It is never shown again after saving.',
  'wz.secretKeep': 'Leave blank to keep the current value.',
  'wz.emailListHint': 'One email per line.',
  'wz.cidrListHint': 'One address or range per line.',
  'wz.tagsHint': 'Type and press Enter to add.',
  'wz.tagsAdd': 'Add',
  'wz.tagsExisting': 'Existing tags',
  'wz.tagsUsed': '{n} assets',
  'wz.tagsDictionary': 'from the tag dictionary',
  'wz.tagsRemove': 'Remove {value}',
  'wz.example': 'Example: {value}',
  'wz.detected': 'Detected: {value}',
  'wz.useDetected': 'use the detected',
  'wz.checking': 'Checking…',
  'wz.tooManySteps': 'This wizard has {n} steps; the limit is 7 (RF-NOC-01).',
  'wz.selectArea': 'Select all in {area}',
  'wz.clearArea': 'Clear {area}',
  'wz.noOptions': 'No options available.',
  'wz.selected.one': '{count} selected',
  'wz.selected.other': '{count} selected',

  'wz.v.required': 'This field is required.',
  'wz.v.requiredFix': 'Fill it in to continue.',
  'wz.v.email': '“{value}” is not an email address.',
  'wz.v.emailFix': 'Use name@company.example.',
  'wz.v.tooMany': 'Too many items (at most {n}).',
  'wz.v.cidr': '“{value}” is not an address or range.',
  'wz.v.cidrFix': 'Use something like 198.51.100.0/24.',
  'wz.v.url': 'This is not a web address.',
  'wz.v.urlFix': 'Start with https://',
  'wz.v.number': 'Type a number.',
  'wz.v.range': 'Out of the allowed range.',
  'wz.v.minItems': 'Choose at least {n}.',
  'wz.v.maxLength': 'Too long (at most {n} characters).',
  'wz.v.pattern': 'Invalid format.',
  'wz.invalid.one': '{count} field needs attention.',
  'wz.invalid.other': '{count} fields need attention.',
  'wz.invalidFix': 'Fix the highlighted fields to continue. Nothing you filled in was lost.',

  'err.title': 'Could not continue',
  'err.what': 'What happened',
  'err.why': 'Why',
  'err.fix': 'How to fix',
  'err.fields': 'Fields that need attention',
  'err.ref': 'Reference: {ref}',
  'err.details': 'Technical details (for support)',
  'err.refLabel': 'Reference',
  'err.refHint': 'When you contact support, send this reference: it finds the exact event in the logs.',
  'err.code': 'Error code',
  'err.message': 'Original message',
  'err.crashTitle': 'This screen could not be shown',
  'err.reload': 'Reload the page',

  'problem.network.what': 'Could not reach the Hive server.',
  'problem.network.why': 'The connection dropped or the server is restarting.',
  'problem.network.fix': 'Check your connection and try again in a moment.',
  'problem.forbidden.what': "You don't have permission for this action.",
  'problem.forbidden.why': 'Your active profile does not allow this action.',
  'problem.forbidden.fix': 'Ask an administrator, or switch to a profile that allows it.',
  'problem.authentication-required.what': 'Sign in to continue.',
  'problem.invalid-token.what': 'Your session is no longer valid.',
  'problem.invalid-token.why': 'The sign-in expired, was revoked or belongs to another environment.',
  'problem.invalid-token.fix': 'Sign in again.',
  'problem.mfa-required.what': 'This profile requires multi-factor authentication.',
  'problem.mfa-required.why': 'Privileged profiles always require MFA, even when the identity provider does not ask for it.',
  'problem.mfa-required.fix': 'Sign in again and confirm with your authenticator app.',
  'problem.unexpected-error.what': 'Something went wrong on our side.',
  'problem.unexpected-error.fix': 'Try again. If it keeps happening, contact support with the reference in the technical details.',
  'problem.not-found.what': 'This item no longer exists.',
  'problem.not-found.fix': 'Refresh the list; someone may have removed it.',
  'problem.invalid-fields.what': 'Some fields need attention.',
  'problem.invalid-fields.fix': 'Fix the highlighted fields and try again.',
  'problem.malformed-body.what': 'The request could not be read.',
  'problem.malformed-body.fix': 'Reload the page and try again.',
  'problem.already-exists.what': 'An item with this name already exists.',
  'problem.already-exists.fix': 'Use another name.',
  'problem.last-method.what': 'Keep at least one way to sign in.',
  'problem.last-method.why': 'Nobody could sign in otherwise.',
  'problem.last-method.fix': 'Turn on another method first.',
  'problem.admin-lockout.what': 'This change would lock administrators out.',
  'problem.admin-lockout.fix': 'The administrator profile must keep user and profile administration.',
  'problem.builtin-profile.what': "Default profiles can't be deleted.",
  'problem.builtin-profile.fix': 'Edit it or create a new one.',
  'problem.profile-in-use.what': 'People still have this profile.',
  'problem.profile-in-use.fix': 'Move them to another profile first.',
  'problem.profile-required.what': 'Every person needs at least one profile.',
  'problem.profile-required.fix': 'Choose a profile.',
  'problem.self-disable.what': "You can't disable your own access.",
  'problem.self-disable.fix': 'Ask another administrator.',
  'problem.last-admin.what': 'This is the last active administrator.',
  'problem.last-admin.fix': 'Give the administrator profile to another person first.',
  'problem.not-invited.what': 'This person already signed in.',
  'problem.invite-not-sent.what': 'The invite email could not be sent.',
  'problem.invite-not-sent.why': 'The email service did not accept it.',
  'problem.invite-not-sent.fix': 'Copy the sign-in address and send it another way.',
  'problem.account-revoked.what': 'This integration account was revoked.',
  'problem.account-revoked.fix': 'Create a new integration account.',
  'problem.use-not-available.what': "This use is not available in this installation.",
  'problem.use-not-available.why': "It is offered on demand.",
  'problem.consent-required.what': 'This use needs extra permission from the provider.',
  'problem.consent-required.why': 'The connection was approved without it.',
  'problem.consent-required.fix': 'Open the consent, approve it at the provider and try again.',
  'problem.slug-taken.what': 'This address is already in use.',
  'problem.slug-taken.fix': 'Choose another address for the company.',
  'problem.profile-not-assigned.what': 'This profile is not assigned to you.',
  'problem.profile-not-assigned.fix': 'Choose one of your profiles.',
  'problem.field.required': 'Required.',
  'problem.field.invalidFormat': 'Invalid format.',
  'problem.field.unknownProfile': 'Unknown profile.',
  'problem.unexpected-error.why': 'An unexpected error happened while handling the request.',
  'problem.not-found.why': 'It may have been removed, or the link is old.',
  'problem.invalid-fields.why': 'Some values are missing or not in the expected format.',
  'problem.timeout.what': 'The server took too long to answer.',
  'problem.timeout.why': 'It may be busy, or the connection is slow.',
  'problem.timeout.fix': 'Wait a moment and try again.',
  'problem.bad-request.what': 'The request was not accepted.',
  'problem.bad-request.why': 'Some of the information sent was not in the expected form.',
  'problem.bad-request.fix': 'Reload the page and try again.',
  'problem.unauthorized.what': 'Your session has ended.',
  'problem.unauthorized.why': 'The sign-in expired or was revoked.',
  'problem.unauthorized.fix': 'Sign in again to continue.',
  'problem.conflict.what': 'Someone changed this item at the same time.',
  'problem.conflict.why': 'Your change conflicts with the current version.',
  'problem.conflict.fix': 'Reload to see the latest version and try again.',
  'problem.rate-limited.what': 'Too many requests in a short time.',
  'problem.rate-limited.why': 'Hive limits repeated attempts to protect the service.',
  'problem.rate-limited.fix': 'Wait a minute and try again.',
  'problem.unavailable.what': 'Hive is temporarily unavailable.',
  'problem.unavailable.why': 'The server is restarting or under maintenance.',
  'problem.unavailable.fix': 'Try again in a few minutes.',
  'problem.bad-response.what': 'The server sent an answer Hive could not read.',
  'problem.bad-response.why': 'A proxy or gateway between you and Hive may have answered instead of the server.',
  'problem.bad-response.fix': 'Reload the page. If it keeps happening, contact support with the reference in the technical details.',

  'perm.denied': 'Your active profile ({profile}) does not allow this.',
  'perm.ask': 'Ask an administrator, or switch to a profile that allows it.',

  'session.expiredTitle': 'Your session expired',
  'session.expiredText': 'Sign in again to continue. What you were filling in stays saved as a draft.',
  'session.signInAgain': 'Sign in again',

  'help.title': 'Help',
  'help.open': 'Help for this screen',
  'help.close': 'Close help',
  'help.tabContext': 'This screen',
  'help.tabAsk': 'Ask the assistant',
  'help.search': 'Search the help',
  'help.searchPlaceholder': 'E.g. invite, token, MFA',
  'help.noResults': 'Nothing found. Try other words or ask the assistant.',
  'help.step': 'Step {n} of {total}',
  'help.whatIs': 'What is this?',
  'help.whatIsDesc': 'Show a tip when you hover or focus a field',
  'help.whatIsOn': '“What is this?” is on: hover or focus a field.',
  'help.whatIsOff': '“What is this?” is off.',
  'help.fieldTipDefault': 'If in doubt, open “Ask the assistant” in the help panel.',
  'help.askPlaceholder': 'Your question',
  'help.askButton': 'Ask',
  'help.askEmpty': 'Ask in your own words, for example: “how do I invite a person?”',
  'help.askHint': 'Answers come from the manual, without AI. The assistant never saves anything by itself.',
  'help.you': 'You',
  'help.assistant': 'Assistant',
  'help.found': 'These sections of the manual answer it:',
  'help.noAnswer': "I couldn't find this in the manual for this version.",
  'help.openWizard': 'Open the assistant',
  'help.offerTicket': 'Open a support ticket with this question',
  'help.ticketTitle': 'Open a support ticket?',
  'help.ticketText': 'The service provider receives your question and the screen you are on, without personal data. The gap is also recorded to improve the manual.',
  'help.ticketOk': 'Open ticket',
  'help.ticketDone': "Request recorded. Support tickets are not opened from the console: your administrator was not notified automatically.",
  'help.readMore': 'Read the full article',
  'help.pageButton': 'Help',
  'help.openManual': 'Open in the manual',
  'help.backToScreen': 'Back to this screen',
  'help.unavailable': 'The help could not be loaded right now.',
  'help.onThisPage': 'On this page',
  'help.backToResults': 'Back to the results',
  'help.searchFailed': 'The search could not be completed. Try again in a moment.',
  'help.articleFailed': 'This article could not be opened right now.',

  'theme.label': 'Theme',
  'theme.system': 'System',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'theme.gray': 'Gray',
  'theme.button': 'Theme: {name}. Click to change',
  'theme.changed': 'Theme: {name}.',
  'lang.label': 'Language',

  'pwa.updateReady': 'A new version of Hive is ready. It applies when you reload — nothing you are filling in is lost.',
  'pwa.reload': 'Reload',
  'pwa.updated': 'Hive was updated.',

  'diag.waiting': 'waiting',
  'diag.running': 'testing…',
  'help.aiAnswer': 'Answer by the AI, based on the sections of the manual below.',
  'help.noAi': 'Without AI: {reason}',
  'ui.onDemand': "On demand",
  // layout A + C: painel de contexto, tabela, seleção, detalhe, mapa de pressão e rodapé de status
  'ui.crumbs': 'Breadcrumb',
  'ui.ctx.collapse': 'Collapse panel',
  'ui.ctx.expand': 'Show panel',
  'ui.table.selectAll': 'Select all',
  'ui.table.selectRow': 'Select {name}',
  'ui.table.actions': 'Actions',
  'ui.table.empty': 'Nothing to show.',
  'ui.table.loadMore': 'Load more ({n} left)',
  'ui.table.more': 'Load more',
  'ui.table.showing': 'Showing {shown} of {total}',
  'ui.table.page': 'Page {page} of {pages}',
  'ui.table.prev': 'Previous page',
  'ui.table.next': 'Next page',
  'ui.sel.count.one': '{count} selected',
  'ui.sel.count.other': '{count} selected',
  'ui.sel.clear': 'Clear selection',
  'ui.detail.close': 'Close details',
  'ui.pressure.colorBy': 'Color by',
  'ui.pressure.noData': 'no data',
  'ui.pressure.legend': 'Legend',
  'ui.status.label': 'Status',
  'ui.status.updated': 'data {age} ago',
  'ui.status.updatedWhat': '{what} {age} ago',
  'ui.status.approvals.one': '{count} action awaiting approval',
  'ui.status.approvals.other': '{count} actions awaiting approval',
  'ui.cmd.group': 'Commands',
  'ui.export.button': 'Export',
  'ui.export.menu': 'Export options',
  'ui.export.csv': 'CSV (spreadsheet)',
  'ui.export.xlsx': 'Excel (XLSX)',
  'ui.export.pdf': 'PDF',
  'ui.export.png': 'Image (PNG)',
  'ui.export.svg': 'Image (SVG)',
  'ui.export.html': 'Interactive HTML (opens offline)',
  'ui.export.footer': 'Exported from {product} on {when} by {who}; filters: {filters}',
  'ui.export.noFilters': 'none',
  'ui.export.search': 'Search in the table',
  'ui.export.rows': '{n} of {total} rows',
  'ui.export.layers': 'Layers',
  'ui.export.zoomIn': 'Zoom in',
  'ui.export.zoomOut': 'Zoom out',
  'ui.export.reset': 'Fit',
  'ui.export.theme': 'Light / dark',
  'ui.export.close': 'Close',
  'ui.export.filters': 'Filters',
  'ui.export.done': 'File generated: {name}',
  'ui.export.failed': 'The export could not be generated. Try again.',
  // barra da lista, facetas no painel, gaveta do painel e idade em dias
  'ui.ltb.label': 'List tools',
  'ui.ltb.search': 'Search',
  'ui.ltb.filters': 'Filters',
  'ui.ltb.filtersN': 'Filters ({n})',
  'ui.ltb.active': 'Active filters',
  'ui.ltb.remove': 'Remove filter {name}',
  'ui.ltb.clear': 'Clear',
  'ui.facet.more': 'Show {n} more',
  'ui.facet.less': 'Show less',
  'ui.facet.search': 'Search in {group}',
  'ui.facet.clear': 'Clear filters',
  'ui.facet.none': 'Nothing matches.',
  'ui.ctx.menu': 'Sections',
  'ui.ctx.panel': 'Screen panel',
  'ui.ctx.openPanel': 'Panel',
  'ui.ctx.closePanel': 'Close panel',
  'ui.age.today': 'today',
  'ui.age.days.one': '{count} day',
  'ui.age.days.other': '{count} days',
  'ui.map.zoomIn': 'Zoom in',
  'ui.map.zoomOut': 'Zoom out',
  'ui.map.fit': 'Fit to frame',
} as const;

export type CommonKey = keyof typeof en;

const ptBR: Record<CommonKey, string> = {
  'ui.skip': 'Ir para o conteúdo',
  'ui.close': 'Fechar',
  'ui.cancel': 'Cancelar',
  'ui.confirm': 'Confirmar',
  'ui.save': 'Salvar',
  'ui.saving': 'Salvando…',
  'ui.back': 'Voltar',
  'ui.next': 'Avançar',
  'ui.edit': 'Editar',
  'ui.copy': 'Copiar',
  'ui.copied': 'Copiado para a área de transferência.',
  'ui.copyFallback': 'Texto selecionado — use Ctrl+C para copiar.',
  'ui.loading': 'Carregando…',
  'ui.retry': 'Tentar de novo',
  'ui.undo': 'Desfazer',
  'ui.dismiss': 'Dispensar',
  'ui.notifications': 'Avisos',
  'ui.openMenu': 'Abrir menu',
  'ui.closeMenu': 'Fechar menu',
  'ui.required': 'obrigatório',
  'ui.optional': 'opcional',
  'ui.show': 'Mostrar',
  'ui.hide': 'Ocultar',
  'ui.yes': 'Sim',
  'ui.no': 'Não',
  'ui.none': '—',
  'ui.search': 'Buscar',
  'ui.all': 'Todos',
  'ui.actions': 'Ações',
  'ui.details': 'Detalhes',
  'ui.loadMore': 'Carregar mais',
  'ui.endOfList': 'Fim da lista',
  'ui.empty': 'Nada aqui ainda.',

  'wz.steps': 'Passos do assistente',
  'wz.stepOf': 'Passo {n} de {total} · {title}',
  'wz.saveDraft': 'Salvar rascunho',
  'wz.draftSavedAt': 'Rascunho salvo às {time}',
  'wz.draftSavedToast': 'Rascunho salvo. Você pode continuar depois de onde parou — nada do que preencheu foi perdido.',
  'wz.draftRestored': 'Recuperamos o rascunho que você salvou {when}. Campos secretos nunca ficam no rascunho.',
  'wz.startOver': 'Começar de novo',
  'wz.cancelTitle': 'Sair do assistente?',
  'wz.cancelText': 'O que você preencheu fica guardado como rascunho e pode ser retomado depois.',
  'wz.cancelOk': 'Sair e guardar rascunho',
  'wz.finish': 'Concluir',
  'wz.reviewLead': 'Confira tudo antes de salvar. Use Editar para voltar a um passo sem perder nada.',
  'wz.permCount': '{count} permissões',
  'wz.secretHidden': 'Oculto — guardado no cofre',
  'wz.secretHint': 'Guardado no cofre. Nunca volta a aparecer depois de salvo.',
  'wz.secretKeep': 'Deixe em branco para manter o valor atual.',
  'wz.emailListHint': 'Um e-mail por linha.',
  'wz.cidrListHint': 'Um endereço ou faixa por linha.',
  'wz.tagsHint': 'Digite e tecle Enter para incluir.',
  'wz.tagsAdd': 'Incluir',
  'wz.tagsExisting': 'Tags existentes',
  'wz.tagsUsed': '{n} ativos',
  'wz.tagsDictionary': 'do dicionário de tags',
  'wz.tagsRemove': 'Remover {value}',
  'wz.example': 'Exemplo: {value}',
  'wz.detected': 'Detectado: {value}',
  'wz.useDetected': 'usar o detectado',
  'wz.checking': 'Conferindo…',
  'wz.tooManySteps': 'Este assistente tem {n} passos; o limite é 7 (RF-NOC-01).',
  'wz.selectArea': 'Marcar tudo em {area}',
  'wz.clearArea': 'Desmarcar {area}',
  'wz.noOptions': 'Nenhuma opção disponível.',
  'wz.selected.one': '{count} selecionado',
  'wz.selected.other': '{count} selecionados',

  'wz.v.required': 'Este campo é obrigatório.',
  'wz.v.requiredFix': 'Preencha para continuar.',
  'wz.v.email': '“{value}” não é um e-mail.',
  'wz.v.emailFix': 'Use nome@empresa.example.',
  'wz.v.tooMany': 'Itens demais (no máximo {n}).',
  'wz.v.cidr': '“{value}” não é um endereço ou faixa.',
  'wz.v.cidrFix': 'Use algo como 198.51.100.0/24.',
  'wz.v.url': 'Isto não é um endereço web.',
  'wz.v.urlFix': 'Comece com https://',
  'wz.v.number': 'Digite um número.',
  'wz.v.range': 'Fora da faixa permitida.',
  'wz.v.minItems': 'Escolha ao menos {n}.',
  'wz.v.maxLength': 'Longo demais (no máximo {n} caracteres).',
  'wz.v.pattern': 'Formato inválido.',
  'wz.invalid.one': '{count} campo precisa de atenção.',
  'wz.invalid.other': '{count} campos precisam de atenção.',
  'wz.invalidFix': 'Corrija os campos destacados para continuar. Nada do que você preencheu foi perdido.',

  'err.title': 'Não foi possível continuar',
  'err.what': 'O que houve',
  'err.why': 'Por quê',
  'err.fix': 'Como resolver',
  'err.fields': 'Campos que precisam de atenção',
  'err.ref': 'Referência: {ref}',
  'err.details': 'Detalhes técnicos (para o suporte)',
  'err.refLabel': 'Referência',
  'err.refHint': 'Ao falar com o suporte, informe esta referência: ela localiza o evento exato nos registros.',
  'err.code': 'Código do erro',
  'err.message': 'Mensagem original',
  'err.crashTitle': 'Não foi possível mostrar esta tela',
  'err.reload': 'Recarregar a página',

  'problem.network.what': 'Não foi possível falar com o servidor do Hive.',
  'problem.network.why': 'A conexão caiu ou o servidor está reiniciando.',
  'problem.network.fix': 'Confira sua conexão e tente de novo em instantes.',
  'problem.forbidden.what': 'Você não tem permissão para esta ação.',
  'problem.forbidden.why': 'Seu perfil ativo não permite esta ação.',
  'problem.forbidden.fix': 'Peça a um administrador ou troque para um perfil que permita.',
  'problem.authentication-required.what': 'Entre para continuar.',
  'problem.invalid-token.what': 'Sua sessão não vale mais.',
  'problem.invalid-token.why': 'A entrada venceu, foi revogada ou é de outro ambiente.',
  'problem.invalid-token.fix': 'Entre de novo.',
  'problem.mfa-required.what': 'Este perfil exige autenticação multifator.',
  'problem.mfa-required.why': 'Perfis privilegiados sempre exigem MFA, mesmo que o provedor de identidade não peça.',
  'problem.mfa-required.fix': 'Entre de novo e confirme com o aplicativo autenticador.',
  'problem.unexpected-error.what': 'Algo deu errado do nosso lado.',
  'problem.unexpected-error.fix': 'Tente de novo. Se continuar, fale com o suporte informando a referência dos detalhes técnicos.',
  'problem.not-found.what': 'Este item não existe mais.',
  'problem.not-found.fix': 'Atualize a lista; alguém pode tê-lo removido.',
  'problem.invalid-fields.what': 'Alguns campos precisam de atenção.',
  'problem.invalid-fields.fix': 'Corrija os campos destacados e tente de novo.',
  'problem.malformed-body.what': 'Não foi possível ler o pedido.',
  'problem.malformed-body.fix': 'Recarregue a página e tente de novo.',
  'problem.already-exists.what': 'Já existe um item com este nome.',
  'problem.already-exists.fix': 'Use outro nome.',
  'problem.last-method.what': 'Mantenha ao menos um jeito de entrar.',
  'problem.last-method.why': 'Caso contrário, ninguém conseguiria entrar.',
  'problem.last-method.fix': 'Ligue outro método primeiro.',
  'problem.admin-lockout.what': 'Esta mudança deixaria os administradores sem acesso.',
  'problem.admin-lockout.fix': 'O perfil de administrador precisa manter a administração de pessoas e perfis.',
  'problem.builtin-profile.what': 'Perfis padrão não podem ser excluídos.',
  'problem.builtin-profile.fix': 'Edite-o ou crie um novo.',
  'problem.profile-in-use.what': 'Ainda há pessoas com este perfil.',
  'problem.profile-in-use.fix': 'Mova-as para outro perfil primeiro.',
  'problem.profile-required.what': 'Toda pessoa precisa de ao menos um perfil.',
  'problem.profile-required.fix': 'Escolha um perfil.',
  'problem.self-disable.what': 'Você não pode desativar o próprio acesso.',
  'problem.self-disable.fix': 'Peça a outro administrador.',
  'problem.last-admin.what': 'Este é o último administrador ativo.',
  'problem.last-admin.fix': 'Dê o perfil de administrador a outra pessoa primeiro.',
  'problem.not-invited.what': 'Esta pessoa já entrou.',
  'problem.invite-not-sent.what': 'Não foi possível enviar o e-mail do convite.',
  'problem.invite-not-sent.why': 'O serviço de e-mail não aceitou o envio.',
  'problem.invite-not-sent.fix': 'Copie o endereço de entrada e envie por outro meio.',
  'problem.account-revoked.what': 'Esta conta de integração foi revogada.',
  'problem.account-revoked.fix': 'Crie uma nova conta de integração.',
  'problem.use-not-available.what': "Este uso não está disponível nesta instalação.",
  'problem.use-not-available.why': "Ele é oferecido sob demanda.",
  'problem.consent-required.what': 'Este uso precisa de permissão extra do provedor.',
  'problem.consent-required.why': 'A conexão foi aprovada sem ela.',
  'problem.consent-required.fix': 'Abra o consentimento, aprove no provedor e tente de novo.',
  'problem.slug-taken.what': 'Este endereço já está em uso.',
  'problem.slug-taken.fix': 'Escolha outro endereço para a empresa.',
  'problem.profile-not-assigned.what': 'Este perfil não é seu.',
  'problem.profile-not-assigned.fix': 'Escolha um dos seus perfis.',
  'problem.field.required': 'Obrigatório.',
  'problem.field.invalidFormat': 'Formato inválido.',
  'problem.field.unknownProfile': 'Perfil desconhecido.',
  'problem.unexpected-error.why': 'Aconteceu um erro inesperado ao tratar o pedido.',
  'problem.not-found.why': 'Ele pode ter sido removido, ou o link é antigo.',
  'problem.invalid-fields.why': 'Alguns valores estão faltando ou fora do formato esperado.',
  'problem.timeout.what': 'O servidor demorou demais para responder.',
  'problem.timeout.why': 'Ele pode estar ocupado, ou a conexão está lenta.',
  'problem.timeout.fix': 'Aguarde um instante e tente de novo.',
  'problem.bad-request.what': 'O pedido não foi aceito.',
  'problem.bad-request.why': 'Parte das informações enviadas não estava no formato esperado.',
  'problem.bad-request.fix': 'Recarregue a página e tente de novo.',
  'problem.unauthorized.what': 'Sua sessão terminou.',
  'problem.unauthorized.why': 'A entrada venceu ou foi revogada.',
  'problem.unauthorized.fix': 'Entre de novo para continuar.',
  'problem.conflict.what': 'Outra pessoa alterou este item ao mesmo tempo.',
  'problem.conflict.why': 'Sua alteração conflita com a versão atual.',
  'problem.conflict.fix': 'Recarregue para ver a versão mais recente e tente de novo.',
  'problem.rate-limited.what': 'Muitos pedidos em pouco tempo.',
  'problem.rate-limited.why': 'O Hive limita tentativas repetidas para proteger o serviço.',
  'problem.rate-limited.fix': 'Aguarde um minuto e tente de novo.',
  'problem.unavailable.what': 'O Hive está temporariamente indisponível.',
  'problem.unavailable.why': 'O servidor está reiniciando ou em manutenção.',
  'problem.unavailable.fix': 'Tente de novo em alguns minutos.',
  'problem.bad-response.what': 'O servidor mandou uma resposta que o Hive não conseguiu ler.',
  'problem.bad-response.why': 'Um proxy ou gateway entre você e o Hive pode ter respondido no lugar do servidor.',
  'problem.bad-response.fix': 'Recarregue a página. Se continuar, fale com o suporte informando a referência dos detalhes técnicos.',

  'perm.denied': 'Seu perfil ativo ({profile}) não permite isto.',
  'perm.ask': 'Peça a um administrador ou troque para um perfil que permita.',

  'session.expiredTitle': 'Sua sessão expirou',
  'session.expiredText': 'Entre de novo para continuar. O que você estava preenchendo fica guardado como rascunho.',
  'session.signInAgain': 'Entrar de novo',

  'help.title': 'Ajuda',
  'help.open': 'Ajuda desta tela',
  'help.close': 'Fechar ajuda',
  'help.tabContext': 'Esta tela',
  'help.tabAsk': 'Pergunte ao assistente',
  'help.search': 'Procurar na ajuda',
  'help.searchPlaceholder': 'Ex.: convite, token, MFA',
  'help.noResults': 'Nada encontrado. Tente outras palavras ou pergunte ao assistente.',
  'help.step': 'Passo {n} de {total}',
  'help.whatIs': 'O que é isto?',
  'help.whatIsDesc': 'Mostrar uma dica ao passar o mouse ou focar num campo',
  'help.whatIsOn': '“O que é isto?” ligado: passe o mouse ou foque num campo.',
  'help.whatIsOff': '“O que é isto?” desligado.',
  'help.fieldTipDefault': 'Se tiver dúvida, abra “Pergunte ao assistente” no painel de ajuda.',
  'help.askPlaceholder': 'Sua pergunta',
  'help.askButton': 'Perguntar',
  'help.askEmpty': 'Pergunte do seu jeito, por exemplo: “como convido uma pessoa?”',
  'help.askHint': 'As respostas vêm do manual, sem IA. O assistente nunca salva nada sozinho.',
  'help.you': 'Você',
  'help.assistant': 'Assistente',
  'help.found': 'Estas seções do manual respondem:',
  'help.noAnswer': 'Não achei esse assunto no manual desta versão.',
  'help.openWizard': 'Abrir o assistente',
  'help.offerTicket': 'Abrir chamado no suporte com esta pergunta',
  'help.ticketTitle': 'Abrir chamado no suporte?',
  'help.ticketText': 'O provedor de serviços recebe a sua pergunta e a tela em que você está, sem dados pessoais. A lacuna também fica registrada para melhorar o manual.',
  'help.ticketOk': 'Abrir chamado',
  'help.ticketDone': "Pedido registrado. Chamados de suporte não são abertos pela console: o administrador não foi avisado automaticamente.",
  'help.readMore': 'Ler o artigo completo',
  'help.pageButton': 'Ajuda',
  'help.openManual': 'Abrir no manual',
  'help.backToScreen': 'Voltar a esta tela',
  'help.unavailable': 'Não foi possível carregar a ajuda agora.',
  'help.onThisPage': 'Nesta página',
  'help.backToResults': 'Voltar aos resultados',
  'help.searchFailed': 'Não foi possível concluir a busca. Tente de novo em instantes.',
  'help.articleFailed': 'Não foi possível abrir este artigo agora.',

  'theme.label': 'Tema',
  'theme.system': 'Do sistema',
  'theme.light': 'Claro',
  'theme.dark': 'Escuro',
  'theme.gray': 'Cinza',
  'theme.button': 'Tema: {name}. Clique para trocar',
  'theme.changed': 'Tema: {name}.',
  'lang.label': 'Idioma',

  'pwa.updateReady': 'Uma nova versão do Hive está pronta. Ela vale ao recarregar — nada do que você está preenchendo se perde.',
  'pwa.reload': 'Recarregar',
  'pwa.updated': 'O Hive foi atualizado.',

  'diag.waiting': 'aguardando',
  'diag.running': 'testando…',
  'help.aiAnswer': 'Resposta da IA, com base nas seções do manual abaixo.',
  'help.noAi': 'Sem IA: {reason}',
  'ui.onDemand': "Sob demanda",
  'ui.crumbs': 'Caminho',
  'ui.ctx.collapse': 'Recolher painel',
  'ui.ctx.expand': 'Mostrar painel',
  'ui.table.selectAll': 'Selecionar todos',
  'ui.table.selectRow': 'Selecionar {name}',
  'ui.table.actions': 'Ações',
  'ui.table.empty': 'Nada para mostrar.',
  'ui.table.loadMore': 'Carregar mais ({n} restantes)',
  'ui.table.more': 'Carregar mais',
  'ui.table.showing': 'Mostrando {shown} de {total}',
  'ui.table.page': 'Página {page} de {pages}',
  'ui.table.prev': 'Página anterior',
  'ui.table.next': 'Próxima página',
  'ui.sel.count.one': '{count} selecionado',
  'ui.sel.count.other': '{count} selecionados',
  'ui.sel.clear': 'Limpar seleção',
  'ui.detail.close': 'Fechar detalhe',
  'ui.pressure.colorBy': 'Cor por',
  'ui.pressure.noData': 'sem dado',
  'ui.pressure.legend': 'Legenda',
  'ui.status.label': 'Situação',
  'ui.status.updated': 'dados há {age}',
  'ui.status.updatedWhat': '{what} há {age}',
  'ui.status.approvals.one': '{count} ação aguardando aprovação',
  'ui.status.approvals.other': '{count} ações aguardando aprovação',
  'ui.cmd.group': 'Comandos',
  'ui.export.button': 'Exportar',
  'ui.export.menu': 'Opções de exportação',
  'ui.export.csv': 'CSV (planilha)',
  'ui.export.xlsx': 'Excel (XLSX)',
  'ui.export.pdf': 'PDF',
  'ui.export.png': 'Imagem (PNG)',
  'ui.export.svg': 'Imagem (SVG)',
  'ui.export.html': 'HTML interativo (abre sem o Hive)',
  'ui.export.footer': 'Exportado do {product} em {when} por {who}; filtros: {filters}',
  'ui.export.noFilters': 'nenhum',
  'ui.export.search': 'Buscar na tabela',
  'ui.export.rows': '{n} de {total} linhas',
  'ui.export.layers': 'Camadas',
  'ui.export.zoomIn': 'Aproximar',
  'ui.export.zoomOut': 'Afastar',
  'ui.export.reset': 'Enquadrar',
  'ui.export.theme': 'Claro / escuro',
  'ui.export.close': 'Fechar',
  'ui.export.filters': 'Filtros',
  'ui.export.done': 'Arquivo gerado: {name}',
  'ui.export.failed': 'Não deu para gerar a exportação. Tente de novo.',
  'ui.ltb.label': 'Ferramentas da lista',
  'ui.ltb.search': 'Buscar',
  'ui.ltb.filters': 'Filtros',
  'ui.ltb.filtersN': 'Filtros ({n})',
  'ui.ltb.active': 'Filtros ativos',
  'ui.ltb.remove': 'Remover o filtro {name}',
  'ui.ltb.clear': 'Limpar',
  'ui.facet.more': 'Mostrar mais {n}',
  'ui.facet.less': 'Mostrar menos',
  'ui.facet.search': 'Procurar em {group}',
  'ui.facet.clear': 'Limpar filtros',
  'ui.facet.none': 'Nada encontrado.',
  'ui.ctx.menu': 'Seções',
  'ui.ctx.panel': 'Painel da tela',
  'ui.ctx.openPanel': 'Painel',
  'ui.ctx.closePanel': 'Fechar painel',
  'ui.age.today': 'hoje',
  'ui.age.days.one': '{count} dia',
  'ui.age.days.other': '{count} dias',
  'ui.map.zoomIn': 'Aproximar',
  'ui.map.zoomOut': 'Afastar',
  'ui.map.fit': 'Ajustar ao quadro',
};

const es: Record<CommonKey, string> = {
  'ui.skip': 'Ir al contenido',
  'ui.close': 'Cerrar',
  'ui.cancel': 'Cancelar',
  'ui.confirm': 'Confirmar',
  'ui.save': 'Guardar',
  'ui.saving': 'Guardando…',
  'ui.back': 'Volver',
  'ui.next': 'Siguiente',
  'ui.edit': 'Editar',
  'ui.copy': 'Copiar',
  'ui.copied': 'Copiado al portapapeles.',
  'ui.copyFallback': 'Texto seleccionado — use Ctrl+C para copiar.',
  'ui.loading': 'Cargando…',
  'ui.retry': 'Reintentar',
  'ui.undo': 'Deshacer',
  'ui.dismiss': 'Descartar',
  'ui.notifications': 'Avisos',
  'ui.openMenu': 'Abrir menú',
  'ui.closeMenu': 'Cerrar menú',
  'ui.required': 'obligatorio',
  'ui.optional': 'opcional',
  'ui.show': 'Mostrar',
  'ui.hide': 'Ocultar',
  'ui.yes': 'Sí',
  'ui.no': 'No',
  'ui.none': '—',
  'ui.search': 'Buscar',
  'ui.all': 'Todos',
  'ui.actions': 'Acciones',
  'ui.details': 'Detalles',
  'ui.loadMore': 'Cargar más',
  'ui.endOfList': 'Fin de la lista',
  'ui.empty': 'Todavía no hay nada aquí.',

  'wz.steps': 'Pasos del asistente',
  'wz.stepOf': 'Paso {n} de {total} · {title}',
  'wz.saveDraft': 'Guardar borrador',
  'wz.draftSavedAt': 'Borrador guardado a las {time}',
  'wz.draftSavedToast': 'Borrador guardado. Puede continuar más tarde donde lo dejó — no se perdió nada de lo que completó.',
  'wz.draftRestored': 'Recuperamos el borrador que guardó {when}. Los campos secretos nunca quedan en el borrador.',
  'wz.startOver': 'Empezar de nuevo',
  'wz.cancelTitle': '¿Salir del asistente?',
  'wz.cancelText': 'Lo que completó queda guardado como borrador y puede retomarse después.',
  'wz.cancelOk': 'Salir y guardar borrador',
  'wz.finish': 'Finalizar',
  'wz.reviewLead': 'Revise todo antes de guardar. Use Editar para volver a un paso sin perder nada.',
  'wz.permCount': '{count} permisos',
  'wz.secretHidden': 'Oculto — guardado en la bóveda',
  'wz.secretHint': 'Guardado en la bóveda. Nunca vuelve a mostrarse después de guardar.',
  'wz.secretKeep': 'Déjelo en blanco para mantener el valor actual.',
  'wz.emailListHint': 'Un correo por línea.',
  'wz.cidrListHint': 'Una dirección o rango por línea.',
  'wz.tagsHint': 'Escriba y pulse Enter para agregar.',
  'wz.tagsAdd': 'Agregar',
  'wz.tagsExisting': 'Etiquetas existentes',
  'wz.tagsUsed': '{n} activos',
  'wz.tagsDictionary': 'del diccionario de etiquetas',
  'wz.tagsRemove': 'Quitar {value}',
  'wz.example': 'Ejemplo: {value}',
  'wz.detected': 'Detectado: {value}',
  'wz.useDetected': 'usar el detectado',
  'wz.checking': 'Verificando…',
  'wz.tooManySteps': 'Este asistente tiene {n} pasos; el límite es 7 (RF-NOC-01).',
  'wz.selectArea': 'Marcar todo en {area}',
  'wz.clearArea': 'Desmarcar {area}',
  'wz.noOptions': 'No hay opciones disponibles.',
  'wz.selected.one': '{count} seleccionado',
  'wz.selected.other': '{count} seleccionados',

  'wz.v.required': 'Este campo es obligatorio.',
  'wz.v.requiredFix': 'Complételo para continuar.',
  'wz.v.email': '“{value}” no es un correo.',
  'wz.v.emailFix': 'Use nombre@empresa.example.',
  'wz.v.tooMany': 'Demasiados elementos (como máximo {n}).',
  'wz.v.cidr': '“{value}” no es una dirección o rango.',
  'wz.v.cidrFix': 'Use algo como 198.51.100.0/24.',
  'wz.v.url': 'Esto no es una dirección web.',
  'wz.v.urlFix': 'Empiece con https://',
  'wz.v.number': 'Escriba un número.',
  'wz.v.range': 'Fuera del rango permitido.',
  'wz.v.minItems': 'Elija al menos {n}.',
  'wz.v.maxLength': 'Demasiado largo (como máximo {n} caracteres).',
  'wz.v.pattern': 'Formato inválido.',
  'wz.invalid.one': '{count} campo necesita atención.',
  'wz.invalid.other': '{count} campos necesitan atención.',
  'wz.invalidFix': 'Corrija los campos resaltados para continuar. No se perdió nada de lo que completó.',

  'err.title': 'No fue posible continuar',
  'err.what': 'Qué pasó',
  'err.why': 'Por qué',
  'err.fix': 'Cómo resolverlo',
  'err.fields': 'Campos que necesitan atención',
  'err.ref': 'Referencia: {ref}',
  'err.details': 'Detalles técnicos (para el soporte)',
  'err.refLabel': 'Referencia',
  'err.refHint': 'Al contactar al soporte, indique esta referencia: ubica el evento exacto en los registros.',
  'err.code': 'Código del error',
  'err.message': 'Mensaje original',
  'err.crashTitle': 'No se pudo mostrar esta pantalla',
  'err.reload': 'Recargar la página',

  'problem.network.what': 'No fue posible comunicarse con el servidor de Hive.',
  'problem.network.why': 'La conexión se cayó o el servidor se está reiniciando.',
  'problem.network.fix': 'Revise su conexión e inténtelo de nuevo en unos instantes.',
  'problem.forbidden.what': 'No tiene permiso para esta acción.',
  'problem.forbidden.why': 'Su perfil activo no permite esta acción.',
  'problem.forbidden.fix': 'Pida a un administrador o cambie a un perfil que lo permita.',
  'problem.authentication-required.what': 'Inicie sesión para continuar.',
  'problem.invalid-token.what': 'Su sesión ya no es válida.',
  'problem.invalid-token.why': 'El inicio de sesión venció, fue revocado o pertenece a otro entorno.',
  'problem.invalid-token.fix': 'Inicie sesión de nuevo.',
  'problem.mfa-required.what': 'Este perfil exige autenticación multifactor.',
  'problem.mfa-required.why': 'Los perfiles privilegiados siempre exigen MFA, aunque el proveedor de identidad no lo pida.',
  'problem.mfa-required.fix': 'Inicie sesión de nuevo y confirme con la aplicación autenticadora.',
  'problem.unexpected-error.what': 'Algo salió mal de nuestro lado.',
  'problem.unexpected-error.fix': 'Inténtelo de nuevo. Si continúa, contacte al soporte con la referencia de los detalles técnicos.',
  'problem.not-found.what': 'Este elemento ya no existe.',
  'problem.not-found.fix': 'Actualice la lista; alguien pudo haberlo eliminado.',
  'problem.invalid-fields.what': 'Algunos campos necesitan atención.',
  'problem.invalid-fields.fix': 'Corrija los campos resaltados e inténtelo de nuevo.',
  'problem.malformed-body.what': 'No fue posible leer la solicitud.',
  'problem.malformed-body.fix': 'Recargue la página e inténtelo de nuevo.',
  'problem.already-exists.what': 'Ya existe un elemento con este nombre.',
  'problem.already-exists.fix': 'Use otro nombre.',
  'problem.last-method.what': 'Mantenga al menos una forma de iniciar sesión.',
  'problem.last-method.why': 'De lo contrario nadie podría iniciar sesión.',
  'problem.last-method.fix': 'Active otro método primero.',
  'problem.admin-lockout.what': 'Este cambio dejaría a los administradores sin acceso.',
  'problem.admin-lockout.fix': 'El perfil de administrador debe mantener la administración de personas y perfiles.',
  'problem.builtin-profile.what': 'Los perfiles predeterminados no pueden eliminarse.',
  'problem.builtin-profile.fix': 'Edítelo o cree uno nuevo.',
  'problem.profile-in-use.what': 'Todavía hay personas con este perfil.',
  'problem.profile-in-use.fix': 'Muévalas a otro perfil primero.',
  'problem.profile-required.what': 'Cada persona necesita al menos un perfil.',
  'problem.profile-required.fix': 'Elija un perfil.',
  'problem.self-disable.what': 'No puede desactivar su propio acceso.',
  'problem.self-disable.fix': 'Pida a otro administrador.',
  'problem.last-admin.what': 'Este es el último administrador activo.',
  'problem.last-admin.fix': 'Dé el perfil de administrador a otra persona primero.',
  'problem.not-invited.what': 'Esta persona ya inició sesión.',
  'problem.invite-not-sent.what': 'No fue posible enviar el correo de la invitación.',
  'problem.invite-not-sent.why': 'El servicio de correo no aceptó el envío.',
  'problem.invite-not-sent.fix': 'Copie la dirección de inicio de sesión y envíela por otro medio.',
  'problem.account-revoked.what': 'Esta cuenta de integración fue revocada.',
  'problem.account-revoked.fix': 'Cree una nueva cuenta de integración.',
  'problem.use-not-available.what': "Este uso no está disponible en esta instalación.",
  'problem.use-not-available.why': "Se ofrece bajo demanda.",
  'problem.consent-required.what': 'Este uso necesita un permiso adicional del proveedor.',
  'problem.consent-required.why': 'La conexión se aprobó sin él.',
  'problem.consent-required.fix': 'Abra el consentimiento, apruébelo en el proveedor e inténtelo de nuevo.',
  'problem.slug-taken.what': 'Esta dirección ya está en uso.',
  'problem.slug-taken.fix': 'Elija otra dirección para la empresa.',
  'problem.profile-not-assigned.what': 'Este perfil no está asignado a usted.',
  'problem.profile-not-assigned.fix': 'Elija uno de sus perfiles.',
  'problem.field.required': 'Obligatorio.',
  'problem.field.invalidFormat': 'Formato inválido.',
  'problem.field.unknownProfile': 'Perfil desconocido.',
  'problem.unexpected-error.why': 'Ocurrió un error inesperado al procesar la solicitud.',
  'problem.not-found.why': 'Pudo haber sido eliminado, o el enlace es antiguo.',
  'problem.invalid-fields.why': 'Faltan algunos valores o no tienen el formato esperado.',
  'problem.timeout.what': 'El servidor tardó demasiado en responder.',
  'problem.timeout.why': 'Puede estar ocupado, o la conexión es lenta.',
  'problem.timeout.fix': 'Espere un momento e inténtelo de nuevo.',
  'problem.bad-request.what': 'La solicitud no fue aceptada.',
  'problem.bad-request.why': 'Parte de la información enviada no tenía el formato esperado.',
  'problem.bad-request.fix': 'Recargue la página e inténtelo de nuevo.',
  'problem.unauthorized.what': 'Su sesión terminó.',
  'problem.unauthorized.why': 'El inicio de sesión venció o fue revocado.',
  'problem.unauthorized.fix': 'Inicie sesión de nuevo para continuar.',
  'problem.conflict.what': 'Otra persona cambió este elemento al mismo tiempo.',
  'problem.conflict.why': 'Su cambio entra en conflicto con la versión actual.',
  'problem.conflict.fix': 'Recargue para ver la versión más reciente e inténtelo de nuevo.',
  'problem.rate-limited.what': 'Demasiadas solicitudes en poco tiempo.',
  'problem.rate-limited.why': 'Hive limita los intentos repetidos para proteger el servicio.',
  'problem.rate-limited.fix': 'Espere un minuto e inténtelo de nuevo.',
  'problem.unavailable.what': 'Hive no está disponible temporalmente.',
  'problem.unavailable.why': 'El servidor se está reiniciando o está en mantenimiento.',
  'problem.unavailable.fix': 'Inténtelo de nuevo en unos minutos.',
  'problem.bad-response.what': 'El servidor envió una respuesta que Hive no pudo leer.',
  'problem.bad-response.why': 'Un proxy o gateway entre usted y Hive pudo haber respondido en lugar del servidor.',
  'problem.bad-response.fix': 'Recargue la página. Si continúa, contacte al soporte con la referencia de los detalles técnicos.',

  'perm.denied': 'Su perfil activo ({profile}) no permite esto.',
  'perm.ask': 'Pida a un administrador o cambie a un perfil que lo permita.',

  'session.expiredTitle': 'Su sesión expiró',
  'session.expiredText': 'Inicie sesión de nuevo para continuar. Lo que estaba completando queda guardado como borrador.',
  'session.signInAgain': 'Iniciar sesión de nuevo',

  'help.title': 'Ayuda',
  'help.open': 'Ayuda de esta pantalla',
  'help.close': 'Cerrar ayuda',
  'help.tabContext': 'Esta pantalla',
  'help.tabAsk': 'Pregunte al asistente',
  'help.search': 'Buscar en la ayuda',
  'help.searchPlaceholder': 'P. ej. invitación, token, MFA',
  'help.noResults': 'No se encontró nada. Pruebe otras palabras o pregunte al asistente.',
  'help.step': 'Paso {n} de {total}',
  'help.whatIs': '¿Qué es esto?',
  'help.whatIsDesc': 'Mostrar una sugerencia al pasar el ratón o enfocar un campo',
  'help.whatIsOn': '“¿Qué es esto?” activado: pase el ratón o enfoque un campo.',
  'help.whatIsOff': '“¿Qué es esto?” desactivado.',
  'help.fieldTipDefault': 'Si tiene dudas, abra “Pregunte al asistente” en el panel de ayuda.',
  'help.askPlaceholder': 'Su pregunta',
  'help.askButton': 'Preguntar',
  'help.askEmpty': 'Pregunte con sus palabras, por ejemplo: “¿cómo invito a una persona?”',
  'help.askHint': 'Las respuestas vienen del manual, sin IA. El asistente nunca guarda nada por sí solo.',
  'help.you': 'Usted',
  'help.assistant': 'Asistente',
  'help.found': 'Estas secciones del manual responden:',
  'help.noAnswer': 'No encontré este tema en el manual de esta versión.',
  'help.openWizard': 'Abrir el asistente',
  'help.offerTicket': 'Abrir un ticket de soporte con esta pregunta',
  'help.ticketTitle': '¿Abrir un ticket de soporte?',
  'help.ticketText': 'El proveedor de servicios recibe su pregunta y la pantalla en la que está, sin datos personales. La carencia también queda registrada para mejorar el manual.',
  'help.ticketOk': 'Abrir ticket',
  'help.ticketDone': "Solicitud registrada. Los tickets de soporte no se abren desde la consola: el administrador no fue avisado automáticamente.",
  'help.readMore': 'Leer el artículo completo',
  'help.pageButton': 'Ayuda',
  'help.openManual': 'Abrir en el manual',
  'help.backToScreen': 'Volver a esta pantalla',
  'help.unavailable': 'No fue posible cargar la ayuda ahora.',
  'help.onThisPage': 'En esta página',
  'help.backToResults': 'Volver a los resultados',
  'help.searchFailed': 'No fue posible completar la búsqueda. Intente de nuevo en un momento.',
  'help.articleFailed': 'No fue posible abrir este artículo ahora.',

  'theme.label': 'Tema',
  'theme.system': 'Del sistema',
  'theme.light': 'Claro',
  'theme.dark': 'Oscuro',
  'theme.gray': 'Gris',
  'theme.button': 'Tema: {name}. Haga clic para cambiar',
  'theme.changed': 'Tema: {name}.',
  'lang.label': 'Idioma',

  'pwa.updateReady': 'Hay una nueva versión de Hive lista. Se aplica al recargar — no se pierde nada de lo que está completando.',
  'pwa.reload': 'Recargar',
  'pwa.updated': 'Hive se actualizó.',

  'diag.waiting': 'esperando',
  'diag.running': 'probando…',
  'help.aiAnswer': 'Respuesta de la IA, basada en las secciones del manual de abajo.',
  'help.noAi': 'Sin IA: {reason}',
  'ui.onDemand': "Bajo demanda",
  'ui.crumbs': 'Ruta',
  'ui.ctx.collapse': 'Contraer panel',
  'ui.ctx.expand': 'Mostrar panel',
  'ui.table.selectAll': 'Seleccionar todos',
  'ui.table.selectRow': 'Seleccionar {name}',
  'ui.table.actions': 'Acciones',
  'ui.table.empty': 'Nada para mostrar.',
  'ui.table.loadMore': 'Cargar más ({n} restantes)',
  'ui.table.more': 'Cargar más',
  'ui.table.showing': 'Mostrando {shown} de {total}',
  'ui.table.page': 'Página {page} de {pages}',
  'ui.table.prev': 'Página anterior',
  'ui.table.next': 'Página siguiente',
  'ui.sel.count.one': '{count} seleccionado',
  'ui.sel.count.other': '{count} seleccionados',
  'ui.sel.clear': 'Limpiar selección',
  'ui.detail.close': 'Cerrar detalle',
  'ui.pressure.colorBy': 'Color por',
  'ui.pressure.noData': 'sin datos',
  'ui.pressure.legend': 'Leyenda',
  'ui.status.label': 'Estado',
  'ui.status.updated': 'datos hace {age}',
  'ui.status.updatedWhat': '{what} hace {age}',
  'ui.status.approvals.one': '{count} acción esperando aprobación',
  'ui.status.approvals.other': '{count} acciones esperando aprobación',
  'ui.cmd.group': 'Comandos',
  'ui.export.button': 'Exportar',
  'ui.export.menu': 'Opciones de exportación',
  'ui.export.csv': 'CSV (hoja de cálculo)',
  'ui.export.xlsx': 'Excel (XLSX)',
  'ui.export.pdf': 'PDF',
  'ui.export.png': 'Imagen (PNG)',
  'ui.export.svg': 'Imagen (SVG)',
  'ui.export.html': 'HTML interactivo (abre sin Hive)',
  'ui.export.footer': 'Exportado de {product} el {when} por {who}; filtros: {filters}',
  'ui.export.noFilters': 'ninguno',
  'ui.export.search': 'Buscar en la tabla',
  'ui.export.rows': '{n} de {total} filas',
  'ui.export.layers': 'Capas',
  'ui.export.zoomIn': 'Acercar',
  'ui.export.zoomOut': 'Alejar',
  'ui.export.reset': 'Encuadrar',
  'ui.export.theme': 'Claro / oscuro',
  'ui.export.close': 'Cerrar',
  'ui.export.filters': 'Filtros',
  'ui.export.done': 'Archivo generado: {name}',
  'ui.export.failed': 'No se pudo generar la exportación. Intente de nuevo.',
  'ui.ltb.label': 'Herramientas de la lista',
  'ui.ltb.search': 'Buscar',
  'ui.ltb.filters': 'Filtros',
  'ui.ltb.filtersN': 'Filtros ({n})',
  'ui.ltb.active': 'Filtros activos',
  'ui.ltb.remove': 'Quitar el filtro {name}',
  'ui.ltb.clear': 'Limpiar',
  'ui.facet.more': 'Mostrar {n} más',
  'ui.facet.less': 'Mostrar menos',
  'ui.facet.search': 'Buscar en {group}',
  'ui.facet.clear': 'Limpiar filtros',
  'ui.facet.none': 'Nada coincide.',
  'ui.ctx.menu': 'Secciones',
  'ui.ctx.panel': 'Panel de la pantalla',
  'ui.ctx.openPanel': 'Panel',
  'ui.ctx.closePanel': 'Cerrar panel',
  'ui.age.today': 'hoy',
  'ui.age.days.one': '{count} día',
  'ui.age.days.other': '{count} días',
  'ui.map.zoomIn': 'Acercar',
  'ui.map.zoomOut': 'Alejar',
  'ui.map.fit': 'Ajustar al marco',
};

export const commonMessages = { en, 'pt-BR': ptBR, es } as const;
